import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Advance, AdvanceCloseActions } from '../models/advance.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdvanceService {

  private url = environment.url;

  constructor(private http: HttpClient) { }

  getAdvances() {
    const url = 'assets/advances.json';
    return this.http.get(url);
  }

  getCosts() {
    const url = 'assets/costs.json';
    return this.http.get(url);
  }

  createAdvance(advance: Advance) {
    return this.http.post(this.url + 'advance', advance);
  }

  fetchAdvances() {
    return this.http.get<Advance[]>(this.url + 'company/advances').pipe(
      map(v => v.map(Advance.adapt))
    );
  }

  fetchAdvance(id) {
    return this.http.get<Advance>(this.url + 'advance/' + id);
  }

  fetchInactiveAdvances() {
    return this.http.get<Advance[]>(this.url + 'company/advances/closed').pipe(
      map(v => v.map(Advance.adapt))
    );
  }

  fetchEmployeeInactiveAdvances(id) {
    return this.http.get<Advance[]>(this.url + `employee/${id}/advances/closed`).pipe(
      map(v => v.map(Advance.adapt))
    );
  }

  fetchEmployeeAdvances(id) {
    return this.http.get<Advance[]>(this.url + 'employee/' + id + '/advances').pipe(
      map(v => v.map(Advance.adapt))
    );
  }

  fetchCurrentUserAdvances() {
    return this.http.get<Advance[]>(this.url + 'profile/navigation/advances').pipe(
      map(v => v.map(Advance.adapt))
    );
  }

  updateAdvance(advance: Advance, advanceId: number) {
    return this.http.post(this.url + 'advance/' + advanceId + '/update', advance);
  }

  closeAdvance(advance: Advance, advanceId: number, action: AdvanceCloseActions) {
    return this.http.post(this.url + 'advance/' + advanceId + '/close/' + action, advance);
  }

  exportAdvance(advanceId: number) {
    return this.http.post(this.url + 'advance/' + advanceId + '/export', {});
  }

  cancelAdvance(advanceId: number) {
    return this.http.post(this.url + 'advance/' + advanceId + '/cancel', {});
  }

  exportToCsv(advanceId: number) {
    return this.http.post(`${this.url}advance/`+ advanceId +'/csv', advanceId, {responseType: 'blob'});
  }
}
